import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

import {
  PaymentMethod,
  UserPaymentPlanOption
} from '../../../generated/graphql';
import { formatCAD } from '../../../utils/currencyFormat';
import InvoiceDetails from '../InvoiceDetails/InvoiceDetails';

interface ProductAccordionProps {
  label: string;
  plan: UserPaymentPlanOption;
  paymentMethod: PaymentMethod;
  isInitial: boolean;
  country: string;
}

const ProductAccordion: React.FC<ProductAccordionProps> = ({
  label,
  plan,
  paymentMethod,
  isInitial,
  country
}) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="ProductAccordion" data-testid={`ProductAccordion-${label}`}>
      <button
        type="button"
        className="flex items-center w-full text-left text-secondary font-semibold uppercase py-2 text-lg"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <span>{label}: </span>
        <span className="ml-1 normal-case text-black">
          {formatCAD.format(plan.totalPayable)}
        </span>
        <FontAwesomeIcon
          icon={open ? faCaretUp : faCaretDown}
          className="ml-2 text-black"
        />
      </button>
      <div className={`overflow-hidden ${open ? '' : 'h-0'}`}>
        <InvoiceDetails
          paymentMethod={paymentMethod}
          paymentPlanOption={plan}
          isInitial={isInitial}
          country={country}
        />
      </div>
    </div>
  );
};

export default ProductAccordion;
